import { browserLocalStorage } from "@/react/lib/browserStorage";

import type { DockMode } from "./types";

// localStorage key for the persisted admin-dock expand/collapse preference.
// Stories/tests clear this between runs so leftover state cannot leak.
export const STORE_KEY = "circle-ai-shell";

export const isDockMode = (value: unknown): value is DockMode =>
  value === "collapsed" || value === "expanded";

export const readStoredDockMode = (): DockMode | undefined => {
  const serializedState = browserLocalStorage.getItem(STORE_KEY);
  if (!serializedState) return undefined;

  try {
    const persistedState: unknown = JSON.parse(serializedState);
    if (
      typeof persistedState !== "object" ||
      persistedState === null ||
      !("state" in persistedState)
    ) {
      return undefined;
    }

    const state = persistedState.state;
    if (typeof state !== "object" || state === null || !("dockMode" in state)) {
      return undefined;
    }

    return isDockMode(state.dockMode) ? state.dockMode : undefined;
  } catch {
    return undefined;
  }
};
